import { IDomainCalculation } from '@web_opxp/features';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import { IDomainProgress } from './types';

export const sortByTimestamp = (domaincalculation: IDomainCalculation[]) => sortBy(domaincalculation, 'timestamp');

export const normalizeCFQScore = (score: IDomainCalculation) => {
  const { cycleId, value, timestamp } = score;
  // change domaincalculation data format, so we can use it for histogram
  // also normalize values: sometimes its 0..100 sometimes 0..10000
  // probably discrepancy between backend and app calculation algorythms
  const normalizedScore = 100 - (value < 101 ? value : Math.ceil(value / 100));
  const domainProgress: IDomainProgress = {
    cycleId,
    time: timestamp,
    normalizedScore,
  };
  return domainProgress;
};

export const findNewerTime = (domainProgress: Array<IDomainProgress>): number => {
  return domainProgress.reduce((acc, val) => {
    return acc > val?.time ? acc : val.time;
  }, 0);
};

export function getLastEvaluationTimestamp(evaluations: IDomainCalculation[]) {
  let timestamp = 0;
  if (!evaluations || !evaluations.length) {
    return timestamp;
  }
  evaluations.forEach((evaluation) => {
    if (evaluation.timestamp > timestamp) {
      timestamp = evaluation.timestamp;
    }
  });
  return timestamp;
}

export const sortDomainProgressByCycle = (domainProgress: Array<IDomainProgress>) => sortBy(domainProgress, 'cycleId');

export const findCycleDomainProgress = (domainProgress: Array<IDomainProgress>, cycleId: number) =>
  find(domainProgress, { cycleId });

export const isDomainProgressPresentForCycle = (domainProgress: Array<IDomainProgress>, cycleId: number) =>
  !!findCycleDomainProgress(domainProgress, cycleId);

export const getFirstAndLastDayTimestamps = (inputJsTimestamp: number) => {
  const date = new Date(inputJsTimestamp);
  // Set the date to the first day of the month
  date.setDate(1);
  date.setHours(0, 0, 0, 0);

  const firstDayTimestamp = date.getTime();

  // Set the date to the last day of the month
  date.setMonth(date.getMonth() + 1);
  date.setDate(0);
  date.setHours(23, 59, 59, 999);

  const lastDayTimestamp = date.getTime();

  return {
    firstDayTimestamp,
    lastDayTimestamp,
  };
};

export const getTimeFromSeconds = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  seconds -= hours * 3600;
  const minutes = Math.floor(seconds / 60);
  return { hours, minutes };
};
